var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.93682 8.85L12.0368 12.75L16.2368 8.85C16.7368 8.45 17.4368 8.45001 17.8368 8.85001C18.2368 9.35001 18.2368 10.05 17.8368 10.45L12.8368 15.15C12.4368 15.55 11.7368 15.55 11.2368 15.15L6.23682 10.45C5.73682 10.05 5.73682 9.25 6.23682 8.85C6.73682 8.45 7.43682 8.45 7.93682 8.85Z","fill":"currentColor"}));
}

ChevronDown.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
